
<div class="opciones" *ngIf="(flagDatosOption)" >

    <!-- SELECT -->
    <mat-form-field appearance="fill">
        <mat-label>Dispositivo</mat-label>
        <mat-select [(value)]="selectedDisp" [(ngModel)]="selectOpcion" (ngModelChange)="onOptionSelected()">
        <!-- <mat-option></mat-option> -->
        <mat-option [value]="option.value" *ngFor="let option of opcionesDisp">{{ option.viewValue }}</mat-option>
        </mat-select>
    </mat-form-field>


    <!-- RADIOBUTTONS OCUPACIÓN -->
    <mat-radio-group *ngIf="(!this.flagFrigo)"
        aria-labelledby="radio-group-label"
        class="radio-group"
        [(ngModel)]="grafica">
    <mat-radio-button class="radio-button" 
        *ngFor="let grafica of data.graficasOcupa; let i =index" 
        [value]="grafica"
        (change)="onOptionradioSelected(grafica)">
            {{grafica.text}}
    </mat-radio-button>
    </mat-radio-group>

    <!-- RADIOBUTTONS FRIGORÍFICO -->
    <mat-radio-group *ngIf="(this.flagFrigo)"
        aria-labelledby="radio-group-label"
        class="radio-group"
        [(ngModel)]="grafica">
    <mat-radio-button class="radio-button" 
        *ngFor="let grafica of data.graficasFridge; let i =index" 
        [value]="grafica"
        (change)="onOptionradioSelected(grafica)">
            {{grafica.text}}
    </mat-radio-button>
    </mat-radio-group>

    <!-- DATEPICKER-1 RANGO DE FECHAS-->
    <mat-form-field appearance="fill" *ngIf="(!verHistorico)">
    
      <mat-label>Rango de fechas</mat-label>
        <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
          <input matStartDate formControlName="start" >
          <input matEndDate formControlName="end" placeholder="End date">
        </mat-date-range-input >
    <!-- placeholder="Start date" -->
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker>
    
            <mat-date-range-picker-actions > 
                <button  mat-button class="btnaplicar" matDateRangePickerCancel > Cancelar </button > 
                <button  mat-button  class="btnaplicar"  matDateRangePickerApply (click)="dateSelected()"> Aplicar </button > 
          </mat-date-range-picker-actions > 
        </mat-date-range-picker>
    
        <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">Invalid start date</mat-error>
        <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">Invalid end date</mat-error>
    </mat-form-field>


    <!-- HISTORICO, De momento lo dejamos comentado -->
    <!-- <mat-label>COMPARACIÓN CON HISTORICO</mat-label>

    <section class="example-section">
        <mat-checkbox [(ngModel)]="verHistorico" (ngModelChange)="checkVerHistorico()">Activar comparación</mat-checkbox>
      </section> -->

    <!-- DATEPICKER-2 FECHA DE 1 SOLO DÍA PARA COMPARACIÓN CON HISTORICO -->
    <!-- <mat-form-field appearance="fill" *ngIf="(verHistorico)">

      <mat-label>Día a comparar</mat-label>
      <mat-datepicker-input [formGroup]="rangeDay" [matDatepicker]="datepicker" >
        <input matInput [matDatepicker]="datepicker"  formControlName="dayHist">
      </mat-datepicker-input>

      <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
      <mat-datepicker #datepicker>

        <mat-datepicker-actions>
          <button  mat-button class="btnaplicar" matDatepickerCancel > Cancelar </button > 
              <button  mat-button  class="btnaplicar"  matDateRangePickerApply (click)="daySelected()"> Aplicar </button > 
        </mat-datepicker-actions>
      </mat-datepicker>
    </mat-form-field> -->

    <!-- Nº DE DÍAS DE LA COMPARACIÓN -->
    <!-- <mat-form-field appearance="fill">
        <mat-label>Media de los últimos</mat-label>
        <input matInput type="number" placeholder="30" [formControl]="diasHistoricoForm">
      </mat-form-field> -->

       <!-- BOTON CARGAR GRÁFICA -->
    <button mat-raised-button class="btnaplicar" (click)="cargarGrafica()">Apicar Cambios</button>
</div>

<!-- <mat-spinner class="spinner" *ngIf="(!flagCargaGrafica)"></mat-spinner> -->

<!-- GRAFICA -->
<app-grafica-bar 
    class="chart" 
    [dataGrafica] = "this.dataGrafica"
    [dataGraficaInactividad] = "this.dataGraficaInactividad"
    [dataGraficaHistorico] = "this.dataGraficaHistorico"
    [dataGraficaInactividadHistorico] = "this.dataGraficaInactividadHistorico"
    [flagCargaGrafica] = "this.flagCargaGrafica"
    

>

</app-grafica-bar>

<!-- [dataGraficaHistorico] = "this.dataGraficaHistorico" -->



<!-- <div class="chart"
     *ngIf="(!flagDatos)"
></div> -->
